import { Tooltip, Typography } from '@mui/material';
import React, { FC, memo, useEffect, useMemo, useState } from 'react';
import moment from 'moment/moment';

const INTERVAL = 60000;

interface NotificationDateFormatProps {
  date: string;
}

export const NotificationDateFormatComponent: FC<NotificationDateFormatProps> = ({ date }) => {
  const [currentTime, setCurrentTime] = useState(moment().utc());

  const formattedFullDate = useMemo(
    () => moment(date).format('MMMM, dddd Do YYYY, h:mm:ss'),
    [date]
  );

  const formattedDate = useMemo(() => {
    const secondsDiff = moment(date).diff(currentTime, 'seconds');
    const duration = moment.duration(secondsDiff, 'seconds');
    const minutes = Math.abs(duration.minutes());
    const hours = Math.abs(duration.hours());
    const days = Math.abs(duration.days());

    if (minutes < 60 && hours === 0) {
      return `${minutes}m`;
    }

    if (hours < 24 && days === 0) {
      return `${hours}h`;
    }

    return `${moment(date).format('MMM DD')}`;
  }, [currentTime, date]);

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(moment().utc()), INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, [setCurrentTime]);

  if (!formattedDate) {
    return null;
  }

  return (
    <Tooltip title={formattedFullDate}>
      <Typography>{formattedDate}</Typography>
    </Tooltip>
  );
};

export const NotificationDateFormat = memo(NotificationDateFormatComponent);
